import * as React from "react";
import { BrowserRouter, Route } from "react-router-dom";
import { Admin, Resource, CustomRoutes } from "react-admin";
import polyglotI18nProvider from "ra-i18n-polyglot";

import dataProvider from "../server/dataProvider";
import { Layout, NotFound } from "../server/layout";
import authProvider from "./security/authProvider";
import { checkPermission } from "../server/security/utils";

import bulgarianMessages from "../server/bulgarianMessages";
import { resources, settings } from "../app";
import Dashboard from "./Dashboard";
import LoginCallback from "./security/LoginCallback";
import SelectProfilePage from "features/SelectProfilePage";
import { authCallbackPath, selectProfilePath } from "./security/securityUtils";

import SessionExpiredDialogHost from "server/components/SessionExpiredDialogHost";

const i18nProvider = polyglotI18nProvider(() => bulgarianMessages, "bg", {
  allowMissing: true,
});

const getResources = permissions => {
  if (settings.noAuth !== true && !permissions) return [];

  const list = [];

  processResources(resources, permissions, list);

  return list;
};

const processResources = (resources, permissions, list) => {
  resources
    .filter(resource => checkPermission(permissions, resource.permission) && !resource.custom)
    .filter(resource => resource.tenancies === undefined || resource.tenancies.includes(settings.tenant))
    .forEach(resource => {
      if (resource.subMenu) {
        processResources(resource.subMenu, permissions, list);
      } else {
        list.push(
          <Resource
            recordRepresentation={resource.recordRepresentation}
            name={resource.name}
            options={{ label: resource.title }}
            list={resource.list}
            create={checkPermission(permissions, resource.createPermission) && resource.create}
            show={checkPermission(permissions, resource.showPermission) && resource.show}
            edit={checkPermission(permissions, resource.editPermission) && resource.edit}
          />,
        );
      }
    });

  const customResources = resources
    .filter(resource => checkPermission(permissions, resource.permission) && resource.custom)
    .filter(resource => resource.tenancies === undefined || resource.tenancies.includes(settings.tenant));

  if (customResources.length > 0) {
    list.push(
      <CustomRoutes>
        {customResources.map(resource => (
          <Route
            key={resource.name}
            path={`/${resource.name}`}
            element={resource.custom}
          />
        ))}
      </CustomRoutes>,
    );
  }
};

const App = ({ title, dashboard, ...rest }) => {
  return (
    <BrowserRouter basename={settings.basename || ""}>
      <SessionExpiredDialogHost />

      <Admin
        disableTelemetry
        dataProvider={dataProvider}
        authProvider={settings.noAuth !== true ? authProvider : null}
        layout={Layout}
        theme={settings.theme}
        catchAll={NotFound}
        title={title}
        dashboard={dashboard ? dashboard : Dashboard}
        i18nProvider={i18nProvider}
        {...rest}
      >
        {getResources}
        <CustomRoutes noLayout>
          <Route
            path={authCallbackPath}
            element={<LoginCallback />}
          />
          <Route
            path={selectProfilePath}
            element={<SelectProfilePage />}
          />
        </CustomRoutes>
      </Admin>
    </BrowserRouter>
  );
};

export default App;
